
export default {
  props: {
    box: {
      type: Boolean,
      default: false,
    },
  },
};
